import React from 'react';
import './LandingPageV2.css';

function ContactDetailsPage() {
  return (
    <div className="landing-v2">
      <header className="landing-v2-header">
        <div className="header-container">
          <div className="logo">
            <img
              src={process.env.PUBLIC_URL + '/logo512.png'}
              alt="Supchats logo"
              className="logo-img"
            />
            <span className="logo-text">Supchats</span>
          </div>
        </div>
      </header>

      <div className="public-page">
        <div className="public-hero">
          <h1>Contact information</h1>
          <p>
            If you prefer to reach us directly, use the contact details below. We reply during
            business hours.
          </p>
        </div>

        <div className="public-section">
          <h2>How to reach Supchats</h2>
          <ul className="contact-details-list">
            <li>
              <strong>Email:</strong>{' '}
              <a href="mailto:support@supchats.com">support@supchats.com</a>
            </li>
            <li>
              <strong>Telegram:</strong>{' '}
              <a href="https://t.me/salematic" target="_blank" rel="noreferrer">
                @salematic
              </a>
            </li>
            <li>
              <strong>WhatsApp:</strong>{' '}
              <a href="https://wa.me/77478693327" target="_blank" rel="noreferrer">
                +7 747 869 33 27
              </a>
            </li>
            <li>
              <strong>Working hours:</strong> 10:00–20:00 (Moscow time, GMT+3)
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ContactDetailsPage;

